import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  {
    num: "01",
    title: "Inspection & décontamination",
    desc: "Chaque véhicule est examiné sous éclairage dédié, lavé à la main puis décontaminé à l'argile pour une surface parfaitement pure.",
  },
  {
    num: "02",
    title: "Correction & polissage",
    desc: "Élimination des rayures, tourbillons et traces d'oxydation par polissage machine en plusieurs étapes calibrées.",
  },
  {
    num: "03",
    title: "Protection durable",
    desc: "Application du traitement choisi : antirouille, coating céramique ou cire haute performance, selon les besoins du véhicule.",
  },
  {
    num: "04",
    title: "Finitions & livraison",
    desc: "Inspection finale minutieuse, dressing des plastiques et des pneus, puis remise du véhicule prêt à impressionner.",
  },
];

export const Process = () => (
  <section id="processus" data-testid="process-section" className="py-28 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <Eyebrow>Notre méthode</Eyebrow>
        <h2 className="font-display font-black uppercase tracking-tighter leading-[0.95] text-4xl mb-20 max-w-2xl">
          Un processus <span className="gold-gradient-text">sans compromis</span>
        </h2>
      </Reveal>

      <div className="space-y-0">
        {STEPS.map((step, i) => (
          <Reveal key={step.num} delay={i * 0.08}>
            <div
              data-testid={`process-step-${step.num}`}
              className="group grid grid-cols-12 gap-6 items-center border-t border-white/10 py-10 lg:py-14 transition-colors duration-500 hover:border-gold/30"
            >
              <span className="col-span-3 sm:col-span-2 font-display font-black text-5xl lg:text-6xl text-outline leading-none transition-all duration-500 group-hover:[-webkit-text-stroke-color:rgba(212,175,55,0.8)]">
                {step.num}
              </span>
              <div className="col-span-9 sm:col-span-6 lg:col-span-5">
                <h3 className="font-display font-bold text-lg lg:text-xl mb-2 group-hover:text-gold transition-colors duration-500">
                  {step.title}
                </h3>
                <p className="text-sm text-white/55 font-light leading-relaxed">{step.desc}</p>
              </div>
              <div className="hidden lg:flex col-span-5 justify-end">
                <span className="h-px w-full max-w-[200px] bg-white/10 group-hover:bg-gold/50 transition-colors duration-700 origin-left scale-x-50 group-hover:scale-x-100" />
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-12 text-xs uppercase tracking-[0.3em] text-white/40">
          Service offert à Drummondville et partout dans le Centre-du-Québec
        </p>
      </Reveal>
    </div>
  </section>
);
